import React, { useState } from 'react';
import { Button } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apis, apiHolder as api } from 'api';
import './index.scss';
import WarnIcon from '@web-common/components/UI/Icons/svgs/WarnSvg';
import { ModalCloseSmall } from '@web-common/components/UI/Icons/icons';
import AttachmentBlockModal from './AttachmentBlockModal';
import { useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import { AppActions } from '@web-common/state/reducer';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailDraftApi = api.api.requireLogicalApi(apis.mailDraftApiImpl);
const NeedTempDialog = (props) => {
    const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
    const { isModalVisible, setIsModalVisible, needSaveMails, onSave, onNotSave, closeWriteNum, maskStyle = {} } = props;
    const [attachmentShow, setAttachmentShow] = useState(false);
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const scheduleDate = useAppSelector(state => state.mailReducer.currentMail.scheduleDate);
    const dispatch = useAppDispatch();
    const signEditModal = useNiceModal('signEditOnWrite');
    const selectSignModal = useNiceModal('selectSignOnWrite');
    const comfirmSaveTemp = () => {
        const sucMails = [];
        const failMails = [];
        Promise.allSettled(needSaveMails.map(mail => mailApi.doSaveTemp({ content: mail, saveDraft: true }))).then(results => {
            results.forEach(result => {
                const { status, value } = result;
                if (status === 'fulfilled') {
                    sucMails.push(value);
                }
                else {
                    failMails.push(value);
                }
                const sucCids = sucMails.map(item => item.cid);
                mailDraftApi.deleteDraftMailByCid(sucCids);
            });
            if (failMails.length === 0) {
                message.success({
                    content: getIn18Text('BAOCUNCAOGAOXIANG'),
                });
                onSave();
                return;
            }
            if (closeWriteNum) {
                if (closeWriteNum === 1) {
                    message.fail({
                        content: `草稿保存失败，页签无法关闭`,
                    });
                }
                else {
                    message.fail({
                        content: `${failMails.length}封邮件保存失败，对应页签无法关闭`,
                    });
                }
            }
            else {
                message.fail({
                    content: `草稿保存失败，页签无法关闭`,
                });
            }
            onSave(failMails.map(item => item.cid));
        });
        setAttachmentShow(false);
    };
    const saveTemp = () => {
        setIsModalVisible(false);
        const someAttachmentUploading = needSaveMails.some(mail => attachments.some(attachment => attachment.mailId === mail.cid && attachment.status && attachment.status !== 'success' && attachment.type !== 'download'));
        if (someAttachmentUploading) {
            setAttachmentShow(true);
            return;
        }
        comfirmSaveTemp();
        closeModel();
    };
    const notSave = () => {
        setIsModalVisible(false);
        onNotSave();
        closeModel();
    };
    const closeModel = () => {
        dispatch(AppActions.changeShowTemplateList({ isShow: false }));
        dispatch(AppActions.changeShowAddTemplatePop({ isShow: false }));
        selectSignModal.hide();
        signEditModal.hide(true);
        dispatch(AppActions.doToggleDiskModal(false));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { wrapClassName: "modal-dialog", maskStyle: maskStyle, getContainer: () => document.body, onCancel: () => {
                setIsModalVisible(false);
            }, visible: isModalVisible, footer: null, closeIcon: React.createElement(ModalCloseSmall, null) },
            React.createElement("div", { className: "modal-content" },
                React.createElement("div", { className: "modal-icon" },
                    React.createElement(WarnIcon, null)),
                React.createElement("div", { className: "modal-text" },
                    React.createElement("div", { className: "title" }, needSaveMails.length > 1
                        ? `${getIn18Text('ZHENGZAIXIEXINZHONG')}
                ${needSaveMails.length}
                ${getIn18Text('FENGBAOCUN')}`
                        : `${getIn18Text('ZHENGZAIXIEXIN')}`),
                    React.createElement("div", { className: "desc" }, scheduleDate ? getIn18Text('BAOCUNWEICAOGAO') : getIn18Text('BUBAOCUNJIANGDIU')),
                    React.createElement("div", { className: "btns confirm-btns" },
                        React.createElement("div", null,
                            React.createElement(Button, { className: "cancel", onClick: () => notSave() }, getIn18Text('BUBAOCUN')),
                            React.createElement(Button, { className: "save-draft", type: "primary", onClick: () => saveTemp() }, getIn18Text('BAOCUN'))))))),
        React.createElement(AttachmentBlockModal, { visible: attachmentShow, closeModal: () => {
                setAttachmentShow(false);
            }, confirm: () => {
                comfirmSaveTemp();
            } })));
};
export default NeedTempDialog;
